import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';


import { Crud, CrudService, ConfigServerService, CustomHttp } from '../../../core';
import { ClienteGrupoEconomico } from '../cliente-grupo-economico';
import { ClienteGrupoEconomicoSearchResponse } from '../cliente-grupo-economico-search-response';
import { ClienteGrupoEconomicoFilter } from '../filter';

@Injectable({
    providedIn: 'root'
})
export class ClienteGrupoEconomicoCrudHttpService implements Crud<ClienteGrupoEconomico> {
    resource = 'clientegrupoeconomico';
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private crudService: CrudService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/${this.resource}`;
    }

    /** Pesquisa os grupos econômicos */
    search(): Observable<ClienteGrupoEconomico[]> {
        return this.crudService.search<ClienteGrupoEconomico>(this.resource);
    }

    /** Pesquisa os grupos econômicos */
    searchWithFilter(filter: ClienteGrupoEconomicoFilter, orderBy: number, orderByDir: string, offset: number, limit: number): Observable<ClienteGrupoEconomicoSearchResponse> {
        // Params
        let params = new HttpParams()
                            .append('orderBy', orderBy ? orderBy.toString() : null)
                            .append('orderByDir', orderByDir ? orderByDir : '')
                            .append('offset', offset ? offset.toString() : '-1')
                            .append('limit', limit ? limit.toString() : '-1');
        // Filter
        if (filter) {
            params = filter.createParams(params);
        }

        return this.customHttp.get<ClienteGrupoEconomicoSearchResponse>(this.pathApi, {params});
    }

    /** Procura um único grupo econômico através do seu ID */
    find(id: number): Observable<ClienteGrupoEconomico> {
        return this.crudService.find<ClienteGrupoEconomico>(this.resource, id);
    }

    /** Carrega um único grupo econômico através do seu ID */
    load(id: number): Observable<ClienteGrupoEconomico> {
        return this.crudService.load<ClienteGrupoEconomico>(this.resource, id);
    }

    /** Insere um novo grupo econômico */
    insert(entity: ClienteGrupoEconomico): Observable<ClienteGrupoEconomico> {
        return this.crudService.insert<ClienteGrupoEconomico>(this.resource, entity);
    }

    /** Altera um grupo econômico existente */
    update(entity: ClienteGrupoEconomico): Observable<ClienteGrupoEconomico> {
        return this.crudService.update<ClienteGrupoEconomico>(this.resource, entity);
    }

    /** Exclui um grupo econômico através do seu ID */
    delete(id: number): Observable<string> {
        return this.crudService.delete(this.resource, id);
    }
}
